export default "__VITE_PUBLIC_ASSET__fd2eacd6__"